
export const STUDENT = "Student";
export const RECEPTIONIST = "Receptionist";
export const ADMIN = 'Admin';
export const formatOptions = (listArray) => {
    return listArray.map((ele) => {
      return { value: ele, label: ele };
    });
  };

  export const customFormatOptions = (listArray,key='classGroup') => {
    return listArray.map((ele) => {
      return { value: ele.id, label: ele.name };
    });
  };

export const getReqValue = (data)=>{
  let value = null;
  if(data.length >  0){
     value = data[0].value
  }
  return value;
}
